/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Palette interface.
 */
export function instanceOfPalette(value) {
    return true;
}
export function PaletteFromJSON(json) {
    return PaletteFromJSONTyped(json, false);
}
export function PaletteFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'primary': json['primary'] == null ? undefined : json['primary'],
        'usePrimary': json['usePrimary'] == null ? undefined : json['usePrimary'],
        'secondary': json['secondary'] == null ? undefined : json['secondary'],
        'useSecondary': json['useSecondary'] == null ? undefined : json['useSecondary'],
        'error': json['error'] == null ? undefined : json['error'],
        'useError': json['useError'] == null ? undefined : json['useError'],
        'info': json['info'] == null ? undefined : json['info'],
        'useInfo': json['useInfo'] == null ? undefined : json['useInfo'],
        'success': json['success'] == null ? undefined : json['success'],
        'useSuccess': json['useSuccess'] == null ? undefined : json['useSuccess'],
        'warning': json['warning'] == null ? undefined : json['warning'],
        'useWarning': json['useWarning'] == null ? undefined : json['useWarning'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}
export function PaletteToJSON(json) {
    return PaletteToJSONTyped(json, false);
}
export function PaletteToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'primary': value['primary'],
        'usePrimary': value['usePrimary'],
        'secondary': value['secondary'],
        'useSecondary': value['useSecondary'],
        'error': value['error'],
        'useError': value['useError'],
        'info': value['info'],
        'useInfo': value['useInfo'],
        'success': value['success'],
        'useSuccess': value['useSuccess'],
        'warning': value['warning'],
        'useWarning': value['useWarning'],
        'id': value['id'],
    };
}
